<template>
	<div class="event-statistic">
		<PageHeader>
			<StatisticsLinkList />
		</PageHeader>
		<SelectListTab
			v-model="selectedTab"
			:tabList="tabList"
			class="event-statistic__tab"
		/>
		<section class="event-statistic__content">
			<EventSkinStatistics v-if="selectedTab === '피부 타입별 응모 수'" />
			<EventGenderStatistics v-if="selectedTab === '성별별 응모 수'" />
			<EventAgeStatistics v-if="selectedTab === '연령별 응모 수'" />
			<EventPeriodStatistics v-if="selectedTab === '기간별 응모 수'" />
			<EventTimeStatistics v-if="selectedTab === '시간별 응모 수'" />
		</section>
	</div>
</template>
<script>
	import PageHeader from '@/components/PageHeader.vue';
	import StatisticsLinkList from '@/components/operation/StatisticsLinkList.vue';
	import SelectListTab from '@/components/common/SelectListTab';
	import EventAgeStatistics from '@/components/operation/EventStatistic/EventAgeStatistics.vue';
	import EventSkinStatistics from '@/components/operation/EventStatistic/EventSkinStatistics.vue';
	import EventGenderStatistics from '@/components/operation/EventStatistic/EventGenderStatistics.vue';
	import EventPeriodStatistics from '@/components/operation/EventStatistic/EventPeriodStatistics.vue';
	import EventTimeStatistics from '@/components/operation/EventStatistic/EventTimeStatistics.vue';

	export default {
		name: 'EventSatistics',
		components: {
			PageHeader,
			StatisticsLinkList,
			SelectListTab,
			EventAgeStatistics,
			EventGenderStatistics,
			EventPeriodStatistics,
			EventTimeStatistics,
			EventSkinStatistics,
		},
		data() {
			return {
				tabList: [
					'피부 타입별 응모 수',
					'성별별 응모 수',
					'연령별 응모 수',
					'기간별 응모 수',
					'시간별 응모 수',
				],
				selectedTab: '피부 타입별 응모 수',
			};
		},
		methods: {},
	};
</script>
<style lang="scss" scoped></style>
